module.exports = __webpack_public_path__ + "static/media/score-two.cd2d3d5e.svg";